export const insertIfArr = <T>(condition: boolean, element: T): T[] => {
  return condition ? [element] : [];
};
